import { AuthUser } from '../../models/user.model';

export interface AuthState {
  user:               AuthUser | null;
  token:              string | null;
  refreshToken:       string | null;
  loading:            boolean;
  error:              string | null;
  profileSaving:      boolean;
  profileSaveSuccess: boolean;
  profileError:       string | null;
  passwordSaving:      boolean;
  passwordSaveSuccess: boolean;
  passwordError:       string | null;
}

export const initialAuthState: AuthState = {
  user:               null,
  token:              null,
  refreshToken:       null,
  loading:            false,
  error:              null,
  profileSaving:      false,
  profileSaveSuccess: false,
  profileError:       null,
  passwordSaving:      false,
  passwordSaveSuccess: false,
  passwordError:       null,
};
